
import styled from 'styled-components'

import { VARIANT_SECONDARY } from '../../constants/variants'

import { Label } from './Typography'

export const FormLabel = styled(Label).attrs((props) => ({ variant: VARIANT_SECONDARY, fontSize: '18px', ...props }))`
  margin-bottom: 5px;
  display: inline-block;
  ${({ required, disabled }) => (required && !disabled ? `&:after{
    content: " *";
  }` : '')}
`
